<template lang="pug">
v-app#login
  app-snack-bar
  v-main.login-page
    v-container(fluid fill-height)
      v-layout(align-center justify-center)
        v-flex(xs12 sm4 md4 lg3.5)
          app-alert.-mb-10( v-if="alert"  block :alert="alert" :msg="msgAlert"  :type="'error'" @updateAlert="updateAlert()" :icon="'report_gmailerrorred'")
          v-card.app-card.app-card--without-border.pa-3.login-page-card(max-width='365')
            v-card-text.pt-0.pr-4.pl-4.pb-0.mb-0
            v-flex(class="d-flex justify-end")
              v-btn(href="https://wiki.arce.ce.gov.br/pt-br/taxi-app" target="_blank" icon text)
                v-icon(v-text="'help_outline'")
            v-form.login-page-form.app-form(ref='form' v-model='formModel.valid' lazy-validation @submit.prevent='onSubmit')
              v-card-text.pt-0.pb-0
                .layout.column.align-center
                  img.login-page-form__logo(src='https://cdn.arce.ce.gov.br/logo.svg' alt='Logo Arce')
                  h3.login-page-form__appname(v-text="appName")
                  h5.login-page-form__title.mb-5(v-text="'Faça o login para acessar o sistema'")
                v-text-field(v-model='formModel.placa' prepend-inner-icon='local_taxi' label='Placa *' type='text' outlined :rules='[rules.required]' v-mask="'AAA-#X##'")
                v-text-field(v-model='formModel.renavam' prepend-inner-icon='pin' label='Renavam *' type='text' outlined :rules='[rules.required, rules.isRenavam]' v-mask="['########-#','#########-#','##########-#']")
              v-card-actions.pt-0.pr-4.pl-4
                v-btn.login-page-form__submit(block x-large depressed type='submit' color='primary' :loading='loading' v-text="'Continuar'")
                .alert.alert-danger(v-if='error' v-text="error")
              section.loading(v-if='loading')
              v-alert( class="alert-warning text-justify" dense text)
                | Ao incluir a placa/Renavam e clicar em continuar, o Arce Táxi App irá consultar se o veículo está registrado como táxi no cadastro do Detran Ceará. Caso não esteja cadastrado como táxi, não será possível realizar o login. Procure o Detran Ceará link para   
                a(href="https://www.detran.ce.gov.br/" target="_blank")
                  | https://www.detran.ce.gov.br/
                |  e regularize sua situação.

            v-progress-linear(:active='loading' :indeterminate='loading' absolute bottom color='#2e70b6')

</template>

<script>
import Vue from "vue";
import { throwError } from "rxjs";
import GlobalStore from "@/store/modules/global";
import AuthenticationService from "@/services/authentication.service";
import { APP_NAME } from "@/commons/config";
import { mask } from "vue-the-mask";
import AppAlert from "@/components/AppAlert";

export default Vue.extend({
  directives: {
    mask,
  },
  components: {
    // AppSnackBar: () =>
    //   import(/* webpackPrefetch: true */ "@/components/AppSnackBar"),
    AppAlert,
  },
  data: () => ({
    appName: APP_NAME,
    loading: false,
    formModel: {
      valid: false,
      placa: "",
      renavam: "",
    },
    rules: {
      required: (value) => !!value || "Esse campo deve ser preenchido",
      isRenavam: (value) => {
        const renavam = value.replace("-", "");
        return renavam.length < 9 ? "Renavam fora do padrão" : true; // era 10
      },
    },
    error: "",
    returnUrl: "",
    msgAlert: {},
    alert: false,
  }),
  created() {
    this.returnUrl = this.$route.query.returnUrl || "/";
  },
  methods: {
    onSubmit() {
      const isValid = this.$refs.form.validate();
      if (isValid) {
        this.loading = true;
        const { placa, renavam } = this.formModel;
        // TODO: faz o login com placa e renavam
        AuthenticationService.login(
          placa.replace("-", ""),
          renavam.replace("-", ""),
          this.returnUrl
        ).subscribe(
          (response) =>
            GlobalStore.setSnackBar({
              show: true,
              message: "Entrou no sistemas com sucesso.",
              type: "success",
            }),
          (error) => {
            // throwError(error);
            this.msgAlert = GlobalStore.snackbar.message;
            this.alert = true;
            this.loading = false;
          }
        );
      }
    },
    updateAlert() {
      this.alert = false;
    },
  },
});
</script>

<style scoped lang="scss">
#login {
  .login-page {
    display: flex;
    align-items: center;
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #f1f1f1;

    &-card {
      padding: 30px;
      margin: auto;
    }

    &-form {
      margin-top: 10px;
      margin-bottom: 10px !important;

      &__logo {
        width: 62%;
        margin: 0px auto 20px auto;
        display: table;
      }

      &__title {
        text-align: center;
        font-weight: 400;
        margin: 5px auto;
      }

      &__appname {
        font-size: 25px;
        text-transform: uppercase;
      }
    }
    .text-right {
      display: table;
      margin-right: 0;
      width: 100%;
    }
  }
  .alert-warning {
    font-size: 11px;
  }
}
</style>
